var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunicLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 64,
    viewBox: "0 0 103 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.382 43.8C27.382 48.4 24.982 54.3 21.782 57.5L15.282 64H0.582031L14.382 50.2C15.682 48.9 16.982 45.7 16.982 43.9L16.882 31.8C16.882 27.2 19.282 21.3 22.482 18.1L27.882 12.7C31.082 9.50001 36.882 7.10004 41.482 7.10004H41.582L53.682 7.20001C55.482 7.20001 58.682 5.90004 59.982 4.60004L64.582 0H79.182L67.282 11.9C64.082 15.1 58.282 17.5 53.682 17.5H53.582L41.482 17.4C39.682 17.4 36.482 18.7 35.182 20L29.782 25.4C28.482 26.7 27.182 29.9 27.182 31.7L27.382 43.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3816 20.2C75.3816 15.6 77.7816 9.7 80.9816 6.5L87.4816 0H102.182L88.3816 13.8C87.0816 15.1 85.7816 18.3 85.7816 20.1L85.8816 32.2C85.8816 36.8 83.4816 42.7 80.2816 45.9L74.8816 51.3C71.6816 54.5 65.8816 56.9 61.2816 56.9H61.1816L49.0816 56.8C47.2816 56.8 44.0816 58.1 42.7816 59.4L38.1816 64H23.5816L35.4816 52.1C38.6816 48.9 44.4816 46.5 49.0816 46.5H49.1816L61.2816 46.6C63.0816 46.6 66.2816 45.3 67.5816 44L72.9816 38.6C74.2816 37.3 75.5816 34.1 75.5816 32.3L75.3816 20.2Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunicLogo);
export default __webpack_public_path__ + "static/media/funic-logo.b8e260518c47ee4f9b738dc5ccf099ca.svg";
export { ForwardRef as ReactComponent };